import { Suspense } from 'react';
import { Provider, useSelector } from 'react-redux';
import ScrollToTop from './ScrollToTop';
import { Loader } from 'components/Loader';
import SessionExpiredModal from 'components/SessionExpiredModal';
import { registerSessionExpiredHandler } from 'utils/httpInterceptor';
import { ToastMessages } from 'components/ToastMessages';
import { ToastProvider } from 'contexts/ToastContext';
import store from 'sideEffects/store';
import { useGetDatadogToken } from 'hooks/useAwsRequests';
import { useSessionExpired } from 'hooks/useSessionExpired';
import { selectUser } from 'sideEffects/selectors';
import AppRoutes from './AppRoutes';
import { useEffect } from 'react';

const AppContent = () => {
  const user = useSelector(selectUser);
  useGetDatadogToken(user.personalInfo?.email);

  const { isSessionExpiredModalOpen, handleSessionExpired, handleRedirectToLogin } = useSessionExpired();

  useEffect(() => {
    registerSessionExpiredHandler(handleSessionExpired);
  }, [handleSessionExpired]);

  return (
    <>
      <ScrollToTop />
      <AppRoutes />
      {isSessionExpiredModalOpen && <SessionExpiredModal open onRedirect={handleRedirectToLogin} />}
    </>
  );
};

const App = () => {
  return (
    <Provider store={store}>
      <ToastProvider>
        <ToastMessages />
        <Suspense fallback={<Loader />}>
          <AppContent />
        </Suspense>
      </ToastProvider>
    </Provider>
  );
};

export default App;
